export default class GridRow<T> {
    selected: boolean;
    data: T;
    element: HTMLElement;
    checkbox: HTMLInputElement;
    disabled: boolean;
}
